import React, {PropTypes} from 'react';
import {withRouter} from 'react-router';
import runActions from '_shared/lib/action-runner';
import {Loader} from '@goguardian/based';

import style from './style.scss';

class Loading extends React.Component {

  componentDidMount() {
    const routed = this.props.location ? true : false;
    const actionName = this.props.location ?
      this.props.location.query.actionName : this.props.actionName;

    const startTime = Date.now();
    runActions(actionName, this.props.actionParams).then((nextView) => {
      const doNextView = (nextView) => {
        // replace url so loading page isnt in history
        if (routed) {
          this.props.router.replace({
            pathname: nextView
          });
        } else {
          this.props.router.push({
            pathname: nextView
          });
        }

        if (this.props.onComplete) {
          this.props.onComplete();
        }
      };

      const timeDiff = Date.now() - startTime;
      const minDisplayTime = this.props.minDisplayTime ?
        this.props.minDisplayTime : 0;
      if (timeDiff < minDisplayTime) {
        setTimeout(() => doNextView(nextView), minDisplayTime - timeDiff);
      } else {
        doNextView(nextView);
      }
    });
  }

  render() {
    const loadingText = this.props.children ?
      this.props.children : 'We\'re looking for your information...';
    const headerText = this.props.header ?
      this.props.header : 'Just a sec…';
    const className = this.props.className ?
      this.props.className : style.loadingContainer;
    return (
      <div className={className}>
        <h1>{headerText}</h1>
        <p>{loadingText}</p>
        <Loader width={120} />
      </div>
    );
  }
};

export default withRouter(Loading);



/** WEBPACK FOOTER **
 ** ./src/_shared/components/loading/index.jsx
 **/